export default __webpack_public_path__ + "static/media/guia-4-3.22655234.svg";